export default class Calculate {
    static getMostFastBall(pData, callback, self) {
        let that = this
        this.calcData = {}
        for (let i = 0, len = pData.length; i < len; i++) {
            let d = pData[i]
            if (this.calcData[d.pitchingdata.TaggedPitchType] === undefined) {
                this.calcData[d.pitchingdata.TaggedPitchType] = {
                    name: d.pitchingdata.TaggedPitchType,
                    total: 0,
                    speed: [],
                    speed_per: 100,
                    spinRate: [],
                    spinAngle: [],
                    spinValidSpeed: [],
                    changeVer: [],
                    changeHor: [],
                    changeAngle: [],
                    depth: [],
                    releaseH: [],
                    releaseW: [],
                    extension: [],
                    ave_speed: [],
                    ave_spinRate: [],
                    ave_spinAngle: [],
                    ave_spinValidSpeed: [],
                    ave_changeVer: [],
                    ave_changeHor: [],
                    ave_changeAngle: [],
                    ave_depth: [],
                    ave_releaseH: [],
                    ave_releaseW: [],
                    ave_extension: []
                }
            }
            let dKind = this.calcData[d.pitchingdata.TaggedPitchType]
            dKind.total++
            dKind.speed.push(d.pitchingdata['RelSpeed'] / 1000)
            if (d.pitchingdata['SpinRate'] !== null) {
                dKind.spinRate.push(d.pitchingdata['SpinRate'])
            }
            if (d.pitchingdata['Rifle'] !== null) {
                dKind.spinAngle.push(d.pitchingdata['Rifle'])
            }
            if (d.pitchingdata['w_sin_a'] !== null) {
                dKind.spinValidSpeed.push(d.pitchingdata['w_sin_a'])
            }
            dKind.changeVer.push(d.pitchingdata['InducedVertBreak'] * 100)
            dKind.changeHor.push(d.pitchingdata['HorzBreak'] * 100)
            dKind.changeAngle.push(d.pitchingdata['DeflectionAngle'])
            dKind.depth.push(d.pitchingdata['Depth'] * 100)
            dKind.releaseH.push(d.pitchingdata['RelHeight'] * 100)
            dKind.releaseW.push(d.pitchingdata['RelSide'] * 100)
            dKind.extension.push(d.pitchingdata['Extension'] * 100)
        }
        // 平均とボールスピードの%計算
        if (this.calcData['Fastball'] !== undefined) {
            this.calcData['Fastball'].ave_speed = this.average(this.calcData['Fastball'].speed)
        }
        for (let ballType in this.calcData) {
            let item = this.calcData[ballType]
            item.ave_speed = this.average(item.speed)
            item.ave_spinRate = this.average(item.spinRate)
            item.ave_spinAngle = this.average(item.spinAngle)
            item.ave_spinValidSpeed = this.average(item.spinValidSpeed)
            item.ave_changeVer = this.average(item.changeVer)
            item.ave_changeHor = this.average(item.changeHor)
            item.ave_changeAngle = this.average(item.changeAngle)
            item.ave_depth = this.average(item.depth)
            item.ave_releaseH = this.average(item.releaseH)
            item.ave_releaseW = this.average(item.releaseW)
            item.ave_extension = this.average(item.extension)
            if (ballType !== 'FastBall' && this.calcData['Fastball'] !== undefined) {
                item.speed_per = Math.round(item.ave_speed / this.calcData['Fastball'].ave_speed * 100)
            }
        }
        // 速球を1番目にして球数の多い順番に並び替え
        let tmpAverageData = []
        let fastBallArray = []
        this.sortedCalcData = []
        Object.keys(this.calcData).forEach(function (key) {
            if (key === 'Fastball') {
                fastBallArray.push(that.calcData[key])
            } else {
                tmpAverageData.push(that.calcData[key])
            }
        })
        tmpAverageData.sort(function (a, b) {
            return (a.total < b.total ? 1 : -1)
        })
        this.sortedCalcData = fastBallArray.concat(tmpAverageData)
        // ワンテンポ置いてscrollbarのcalculateSizeを実行させる
        window.setTimeout(function () {
            this.loadComplete = true
        }.bind(this), 10)
        let mostFastBall = this.sortedCalcData.reduce(function (prev, current) {
            if (prev.ave_speed > current.ave_speed) {
                return prev
            } else {
                return current
            }
        })
        if (self && callback) {
            if (typeof callback === 'function') {
                callback.call(self, {
                    defaultBalls: pData,
                    mostFastBall: mostFastBall
                })
            } else {
                self.$emit(callback, {
                    defaultBalls: pData,
                    mostFastBall: mostFastBall
                })
            }
        } else {
            return mostFastBall
        }
    }

    static average(arr) {
        let result
        if (typeof arr === 'object' && arr.length > 0) {
            let key
            let totalNumber = 0
            for (key in arr) {
                totalNumber = totalNumber + Number(arr[key])
            }
            result = Math.round(totalNumber / arr.length)
            return result
        }
        return '―'
    }
}
